// components/auth/UserProfileDropdown.tsx
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { UserAvatar } from "./UserAvatar";
import { UserInfo } from "./UserInfo";
import { UserDropdownMenu } from "./UserDropdownMenu";
import { useAuth } from "@/hooks/useAuth";

export const UserProfileDropdown = () => {
  const { handleLogout } = useAuth();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="relative h-10 w-10 rounded-full">
          <UserAvatar />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <UserInfo />
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <UserDropdownMenu onLogout={handleLogout} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
